import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useAuth, useAppDispatch } from '../../helpers/hooks';
import { logout } from '../../slices/auth/authSlice';

const FormanLayout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  // iOS viewport fix: window.innerHeight ile gerçek yüksekliği ölç
  useEffect(() => {
    const setAppHeight = () => {
      document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
    };
    setAppHeight();
    window.addEventListener('resize', setAppHeight);
    // iOS'ta orientationchange'de de güncelle
    window.addEventListener('orientationchange', () => setTimeout(setAppHeight, 100));
    return () => {
      window.removeEventListener('resize', setAppHeight);
    };
  }, []);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const getInitials = () => {
    if (!user) return 'U';
    const first = user.firstName?.charAt(0) || '';
    const last = user.lastName?.charAt(0) || '';
    return (first + last).toUpperCase() || 'U';
  };

  return (
    <div className="forman-layout">
      {/* Simple Header */}
      <header className="forman-header">
        <div className="forman-header-content">
          <div className="forman-logo">
            <span className="logo-text">ALKA</span>
          </div>

          <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)} className="user-dropdown">
            <DropdownToggle tag="button" className="dropdown-toggle">
              <div className="user-avatar">{getInitials()}</div>
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem header>
                <strong>{user?.firstName} {user?.lastName}</strong>
                <br />
                <small className="text-muted">{user?.role?.displayName}</small>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={handleLogout}>
                <i className="ri-logout-box-line me-2"></i>
                Çıkış Yap
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </header>

      {/* Main Content - Full Screen */}
      <main className="forman-main">
        <Outlet />
      </main>
    </div>
  );
};

export default FormanLayout;
